import React from 'react';

/** Toggle switch matching the design (.ac-switch). */
export const Switch: React.FC<{ on: boolean; onChange: (v: boolean) => void; 'data-testid'?: string }> = ({
  on,
  onChange,
  ...rest
}) => (
  <button
    className={'ac-switch' + (on ? ' on' : '')}
    onClick={() => onChange(!on)}
    aria-pressed={on}
    type="button"
    data-testid={rest['data-testid']}
  />
);
